import { CanvaSettings } from '../types/Canva';
import React, { useState, createContext } from 'react';

type CanvaContextType = {
  canvaSettings: CanvaSettings;
  setCanvaSettings: React.Dispatch<React.SetStateAction<CanvaSettings>>;
  isOpenedModelModal: boolean;
  isOpenedSidebarStyleModal: boolean;
  setIsOpenedModelModal: React.Dispatch<React.SetStateAction<boolean>>;
  setIsOpenedSidebarStyleModal: React.Dispatch<React.SetStateAction<boolean>>;
};

const initialState: CanvaSettings = {
  model: 'Flux.1 Dev with LoRA',
  modelName: 'Flux.1 Dev with LoRA',
  modelId: null,
  modelType: 'text-to-image-lora', // Default to LoRA model type
  style: null,
  project: null,
  image_dimensions: '1024x1024',
  exclude_from_image: '',
  prompt_guidance: 80,
  quality: 30,
  seed: 0,
  sampler: 'DDIM',
  number_of_images: 1,
  imageFormat: 'jpeg',
  pose_and_depth: null,
  canvas_subject: null,
  resolution: null,
  image_urls: null
};

export const CanvaContext = createContext<CanvaContextType>({} as CanvaContextType);

export const CanvaContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [canvaSettings, setCanvaSettings] = useState<CanvaSettings>(initialState);
  const [isOpenedModelModal, setIsOpenedModelModal] = useState(false);
  const [isOpenedSidebarStyleModal, setIsOpenedSidebarStyleModal] = useState(false);


  return (
    <CanvaContext.Provider
      value={{
        canvaSettings,
        setCanvaSettings,
        isOpenedModelModal,
        isOpenedSidebarStyleModal,
        setIsOpenedModelModal,
        setIsOpenedSidebarStyleModal
      }}
    >
      {children}
    </CanvaContext.Provider>
  );
};
